// src/features/wallet/components/WalletStatusBadge.tsx
import type { WalletStatus } from '../data/wallet.mock';

export interface WalletStatusBadgeProps {
  status: WalletStatus;
}

const STATUS_LABEL: Record<WalletStatus, string> = {
  active: 'فعال',
  blocked: 'مسدود شده',
  pending: 'در انتظار بررسی',
};

const STATUS_COLOR_VAR: Record<WalletStatus, string> = {
  active: 'var(--vania-accent-teal, #2fd6a7)',
  blocked: 'var(--vania-accent-rose, #ff6b81)',
  pending: 'var(--vania-accent-amber, #f5b942)',
};

/**
 * Small pill badge mapping a wallet's raw status to its Persian label
 * + accent color. Same shape/markup as
 * commission/components/CommissionStatusBadge.tsx and
 * orders/components/OrderStatusBadge.tsx (label map + color-var map
 * keyed by the union type) — kept local to this feature since the
 * status union (active/blocked/pending) is wallet-specific.
 */
export function WalletStatusBadge({ status }: WalletStatusBadgeProps) {
  const color = STATUS_COLOR_VAR[status];

  return (
    <span className="vania-wallet-status-badge" style={{ color, borderColor: color }}>
      <span aria-hidden className="vania-wallet-status-dot" style={{ backgroundColor: color }} />
      {STATUS_LABEL[status]}
    </span>
  );
}
